import { fetcher, postFetcher } from 'util/Api';
import { getNotificationId } from 'utils/notification';

export const getNotifications = async (page = 1) => fetcher('/api/v1/notifications', { params: { page } });

export const getNotificationSettings = async () => fetcher('/api/v1/notifications/settings');

export const updateNotificationSettings = async payload => postFetcher('/api/v1/notifications/settings', payload);

export const getUnreadCount = async () => fetcher('/api/v1/notifications/unread-count');

export const markRead = async id => {
  const notificationId = getNotificationId(id);

  if (notificationId === null) {
    throw new Error('Invalid notification id');
  }

  return postFetcher('/api/v1/notifications/mark-read', {
    mark_all: false,
    notification_ids: [notificationId],
  });
};

export const markManyRead = async () => postFetcher('/api/v1/notifications/mark-read', { mark_all: true });

export const NotificationAPI = {
  getNotifications,
  getNotificationSettings,
  updateNotificationSettings,
  getUnreadCount,
  markRead,
  markManyRead,
};
